module.exports = "<div class=\"asui-workflow-navbar\" ng-class=\"$ctrl.ngClass\">\n    <ul class=\"nav nav-tabs\">\n        <li ng-repeat=\"item in $ctrl.items\" role=\"presentation\"  ng-class=\"$ctrl.getClass($index)\">\n            <a ng-click=\"$ctrl.navClick(item)\" >{{item.label}}</a>\n        </li>\n    </ul>\n</div>\n<div class=\"modal-body\">\n    <form>\n    <div class=\"as-workflow-container\"></div>\n    </form>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asWorkflow/asWorkflow.component.html
// module id = 699
// module chunks = 0